'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosGridView = function IoIosGridView(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm15 25v-10h10v10h-10z m-10-20h30v30h-30v-30z m27.5 10v-1.2h-6.2v-6.3h-1.3v6.3h-10v-6.3h-1.2v6.3h-6.3v1.2h6.3v10h-6.3v1.3h6.3v6.2h1.2v-6.2h10v6.2h1.3v-6.2h6.2v-1.3h-6.2v-10h6.2z' })
        )
    );
};

exports.default = IoIosGridView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-grid-view.js
// module id = 2412
// module chunks = 0